import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps';
import VueGeolocation from 'vue-browser-geolocation';


import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
Vue.config.productionTip = false
Vue.use(VueGeolocation);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw',
        libraries: 'places',
    },
})

window.axios = require('axios')
    // axios.defaults.baseURL = 'http://192.168.50.75:3200';
axios.defaults.baseURL = 'http://13.232.14.77/'
Vue.prototype.baseURL = "http://13.232.14.77/"
Vue.prototype.mediaURL = "http://13.232.14.77/u/"
    // Vue.prototype.axios = axios
new Vue({
    vuetify,
    router,
    render: h => h(App)
}).$mount('#app')